// extracted by mini-css-extract-plugin
export default {"fs":"_26788aa836 _2e37e1d90f"};